import axios from "axios";
import {
  GET_USER_PORTAL_AUDIT_LOGS_FAIL,
  GET_USER_PORTAL_AUDIT_LOGS_REQUEST,
  GET_USER_PORTAL_AUDIT_LOGS_SUCCESS,
} from "../constants/userPortalAuditLogsConstants";
import { api } from "../../mockData";

// User-portal action: reads the user's JWT from localStorage under the
// `user_${current_user}` key (NOT the admin key), and POSTs to the
// /userportalauditlog endpoint which server-side anchors the user_id filter
// to the JWT identity.
export const getUserPortalAuditLogs = (data) => async (dispatch) => {
  const current_user = localStorage.getItem("current_user");
  const token = JSON.parse(localStorage.getItem(`user_${current_user}`) || "null");

  try {
    dispatch({ type: GET_USER_PORTAL_AUDIT_LOGS_REQUEST });

    const response = await axios.post(
      `${api.dev}/api/userportalauditlog`,
      data,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token?.access_token}`,
        },
        maxBodyLength: Infinity,
      }
    );

    dispatch({
      type: GET_USER_PORTAL_AUDIT_LOGS_SUCCESS,
      payload: response?.data?.data,
    });
  } catch (error) {
    dispatch({
      type: GET_USER_PORTAL_AUDIT_LOGS_FAIL,
      payload: error?.response?.data?.message || error.message,
    });
  }
};
